"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentValues = void 0;
var EnvironmentValues;
(function (EnvironmentValues) {
    EnvironmentValues["DEVELOPMENT"] = "development";
    EnvironmentValues["STAGING"] = "staging";
    EnvironmentValues["DEMO"] = "demo";
    EnvironmentValues["PRODUCTION"] = "production";
})(EnvironmentValues || (exports.EnvironmentValues = EnvironmentValues = {}));
